import { Auth } from '@angular/fire/auth';

import { fireAuthFactory } from './firebase.module';

type FirebaseAuthClient = Pick<Auth, 'authStateReady' | 'currentUser'>;

/**
 * 取得目前 Taiwan Firebase Auth 使用者的 ID token。
 * 登入流程尚未完成時回傳 null，讓 SSO / SOS 登入 API 可以正常呼叫。
 */
export const getFirebaseIdToken = async (
  auth: FirebaseAuthClient = fireAuthFactory('taiwan')
): Promise<string | null> => {
  await auth.authStateReady();

  return auth.currentUser ? auth.currentUser.getIdToken() : null;
};
